// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../pin-cross-reference/state/report';
import actions from '../../actions-list';

const updatePinCrossReferenceReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_PIN_CROSS_REFERENCE_REPORT_SUCCESS]: updatePinCrossReferenceReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updatePinCrossReferenceReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/pin-cross-reference/reducers/report.js